export default __webpack_public_path__ + "static/media/instagram.0a842756.jpg";